import React from "react";

export const ResultCard = ({
  icon,
  title,
  description,
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) => (
  <div className="flex flex-col items-start gap-2 rounded bg-white p-4">
    {icon}
    <h3 className="font-heading text-text-secondary mt-4 text-lg font-medium leading-tight">
      {title}
    </h3>
    <p className="text-text-tertiary text-sm">{description}</p>
  </div>
);
